import styled from 'styled-components';

import { weights } from 'utils/style';
import { darken } from 'polished';

import EmptyListPage from 'components/EmptyListPage/container';

export default styled(EmptyListPage)`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  height: 100%;
  width: 100%;

  img {
    width: 140px;
    margin: 10px;
  }

  h1 {
    margin: 6px;
    font-size: 20px;
    color: var(--grey900);
    font-weight: ${weights('medium')};
  }

  span {
    margin: 0;
    font-size: 20px;
    color: var(--grey700);
    font-weight: ${weights('regular')};
    max-width: 400px;
    text-align: center;
    button,
    a {
      color: var(--primary500);
      span {
        color: var(--primary500);
        &:hover {
          color: ${darken(0.1, '#30a4e3')};
        }
      }
      &:hover {
        color: ${darken(0.1, '#30a4e3')};
      }
    }
  }
`;
